export default __webpack_public_path__ + "static/Ambit-Regular-a5d67e002987bbad69b53e7edcdc05a9.woff";